import { PREMIUM_SUBSCRIPTION_PRICE } from '../constants';

export const healthFaqsData = [
  {
    header: 'What is Wag!?',
    body:
      'Wag! is the #1 app for Pet Parents -- offering 5-star dog walking, pet sitting, veterinary care, and training services nationwide. Book convenient pet care in your neighborhood with the Wag! app. Whether you’re looking for daily walks, planning a trip, stuck at work, or just want your best friend to have some company - any day, anytime pet care is available through the app.',
  },
  {
    header: "How can I ensure I'll get the best response?",
    body:
      'When submitting a question, be sure your question is clearly written with simple language and punctuation. The more detail you can provide, the better the response will be.',
  },
  {
    header: 'What does Vet Chat cost?',
    body:
      `To connect with a vet within minutes, request a vet chat at any time for $30. Chat for up to 24 hours to ensure you get the support you need. Wag! Premium members also receive free veterinary advice as a benefit of their membership. Subscribe to Wag! Premium for $${PREMIUM_SUBSCRIPTION_PRICE} a month.`,
  },
  {
    header: 'Can I use Vet Chat any time of day or night?',
    body:
      'Yes, Vet Chat is available for you to use 24 hours a day and 7 days a week.',
  },
  {
    header: 'Is Vet Chat only for dogs?',
    body:
      'Nope! Vet Chat is available to all pets in your home.',
  },
  {
    header:
      'I’m worried my dog is really sick, is Vet Chat the right fit for me?',
    body:
      'Please visit the veterinarian immediately if your pet is not responding, has lost consciousness, is having seizures, collapsing, has bleeding that won’t stop, has severe trauma or pain, excessive bloating, vomiting or diarrhea, inability to urinate, shallow or rapid breathing, or any discoloration of the gums. These symptoms are the sign of a potentially serious health emergency.',
  },
  {
    header: 'Is Vet Chat a free service?',
    body:
      'The licensed vets who answer in-app questions get paid a service fee each time.',
  },
];
